import { Steps as AntSteps, Button } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { primaryLanguagesChanger } from "../../assets/SVGs/SVGs";
import LookFindrLogo from "../../assets/images/LookfindrLogo";
import queryClient from "../../services/react-query/queryClient";
import { setCurrentLang } from "../../services/store/slices/user";
import LastStep from "./steps/LastStep";
import Step1 from "./steps/Step1";
import Step2 from "./steps/Step2";
import Step25 from "./steps/Step25";
import Step3 from "./steps/Step3";
import Step4 from "./steps/Step4";
import Step5 from "./steps/Step5";
const OnBoardingForm = () => {
  // console.log('currentStep currentStepcurrentStepcurrentStep ..............................');
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({});
  const { team_size_id } = useSelector(
    (state: any) => state.SalonProfile.step1
  );
  const dispatch = useDispatch();
  const currentLang = useSelector((state: any) => state?.user?.currentLang);
  const handelChangeLng = () => {
    dispatch(setCurrentLang(currentLang === "ar" ? "en" : "ar"));
    document
      .getElementsByTagName("html")[0]
      .setAttribute("lang", currentLang === "ar" ? "en" : "ar");
    localStorage.setItem("currentLang", currentLang === "ar" ? "en" : "ar");
    setTimeout(() => {
      // queryClient.clear();
      queryClient.invalidateQueries();
      // window.location.reload();
    }, 500);
  };
  const step25 = useSelector((state: any) => state.SalonProfile.step25);
  const navigate = useNavigate();
  const nextStep = () => {
    setCurrentStep(currentStep + 1);
  };
  const PrevStep = () => {
    setCurrentStep(currentStep - 1);
  };
  console.log(currentStep, "currentStep currentStepcurrentStepcurrentStep");

  const steps: any = [
    <Step1 nextStep={nextStep} data={formData} updateData={setFormData} />,
    <Step2 nextStep={nextStep} data={formData} updateData={setFormData} />,
    // <Step3 nextStep={nextStep} data={formData} updateData={setFormData} />,
    // <Step4 nextStep={nextStep} data={formData} updateData={setFormData} />,
    <Step5 nextStep={nextStep} data={formData} updateData={setFormData} />,
    // <Step6 nextStep={nextStep} data={formData} updateData={setFormData} />,
    <LastStep />,
  ];

  if (team_size_id === 1) {
    const checkLocation = (
      <Step25 nextStep={nextStep} data={formData} updateData={setFormData} />
    );
    steps?.splice(2, 0, checkLocation); // Insert at the desired position
    if (step25?.type === "onsite") {
      const addLocation = (
        <Step3 nextStep={nextStep} data={formData} updateData={setFormData} />
      );
      steps.splice(
        3,
        0,
        addLocation,
        <Step4
          nextStep={nextStep}
          PrevStep={PrevStep}
          data={formData}
          updateData={setFormData}
        />
      ); // Insert at the desired position
    }
  }
  if (team_size_id !== 1) {
    const addLocation = (
      <Step3 nextStep={nextStep} data={formData} updateData={setFormData} />
    );
    steps.splice(
      2,
      0,
      addLocation,
      <Step4
        nextStep={nextStep}
        PrevStep={PrevStep}
        data={formData}
        updateData={setFormData}
      />
    ); // Insert at the desired position
  }

  const showSteps = step25 === 2 ? currentStep < 4 : currentStep < 3;
  const customDotRender = (dot: any, { status }: any) => {
    let dotContent = null;

    switch (status) {
      case "process":
        dotContent = (
          <div
            className={`custom-dot custom-dot-${status} flex items-center -mt-[8px] -mr-3`}
            style={{
              padding: "8px",
              borderRadius: "50%",
              border: "6px solid #EEF0FF",
              backgroundColor: "#00086D",
            }}
          />
        );
        break;
      case "finish":
        dotContent = (
          <div
            className={`custom-dot custom-dot-${status} flex items-center justify-center -mt-[9px] -mr-[12px]`}
            style={{
              padding: "4px",
              width: "28px",
              height: "28px",
              borderRadius: "50%",
              backgroundColor: "#00086D",
            }}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_5744_3246)">
                <path
                  d="M6.75047 12.1277L4.14797 9.52523C3.85547 9.23273 3.38297 9.23273 3.09047 9.52523C2.79797 9.81773 2.79797 10.2902 3.09047 10.5827L6.22547 13.7177C6.51797 14.0102 6.99047 14.0102 7.28297 13.7177L15.218 5.78273C15.5105 5.49023 15.5105 5.01773 15.218 4.72523C14.9255 4.43273 14.453 4.43273 14.1605 4.72523L6.75047 12.1277Z"
                  fill="#EEF0FF"
                />
              </g>
              <defs>
                <clipPath id="clip0_5744_3246">
                  <rect width="18" height="18" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        );
        break;
      case "wait":
        dotContent = (
          <div
            className={`custom-dot custom-dot-${status} flex items-center -mt-[3px] bg-[#B0B0C0] p-2 rounded-full`}
          />
        );
        break;
      default:
        break;
    }

    return dotContent;
  };
  console.log(step25);
  const intl = useIntl();

  return (
    <div className="bg-white container max-md:px-2 max-md:py-12 md:py-12 md:px-16 w-[90%] shadow-2xl rounded-lg flex flex-col items-center justify-center max-md:gap-4 gap-8 relative ">
      {currentStep > 0 && currentStep < 4 && (
        <span
          onClick={() => PrevStep()}
          className="flex items-center w-full gap-2 text-sm font-normal cursor-pointer text-color-gray"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.6037 11.3091C4.80251 11.5024 5.12485 11.5024 5.32366 11.3091L9.39639 7.34954C9.49186 7.25672 9.5455 7.13082 9.5455 6.99956C9.5455 6.86829 9.49186 6.74239 9.39639 6.64957L5.32366 2.68998C5.12485 2.49669 4.80251 2.49669 4.6037 2.68998C4.40489 2.88327 4.40489 3.19665 4.6037 3.38994L8.31644 6.99956L4.6037 10.6092C4.40489 10.8025 4.40489 11.1158 4.6037 11.3091Z"
              fill="#9999A7"
            />
          </svg>
          {intl.formatMessage({
            id: "back",
          })}
        </span>
      )}
      <div className="flex justify-end translate-y-[-20px] items-center w-full">
        <Button
          className="header-lang-btn !text-color-primary hover:!text-color-primary"
          onClick={handelChangeLng}
          icon={primaryLanguagesChanger()}
        >
          {currentLang === "ar" ? "English" : "العربية"}
        </Button>
      </div>
      <LookFindrLogo
        className="max-md:w-[7rem]"
        onClick={() => {
          navigate("/register");
        }}
      />
      {currentStep < 4 && (
        <h3 className="text-2xl font-semibold max-md:text-lg">
          {intl.formatMessage({
            id: "welcomeMsgStep1to3",
          })}
        </h3>
      )}
      {currentStep >= 4 && (
        <h3 className="text-2xl font-semibold max-lg:text-xl">
          {intl.formatMessage({
            id: "welcomeMsgStep4AndBeyond",
          })}
        </h3>
      )}
      {showSteps && (
        <AntSteps
          className={`!border-none`}
          progressDot={customDotRender} // Use custom dot render function
          responsive={false}
          current={currentStep}
          items={[{}, {}, {}]}
        />
      )}
      {steps[currentStep]}
    </div>
  );
};

export default OnBoardingForm;
